import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { EngagementTemplateFlowStepEnum } from 'src/app/shared/components/choose-template-flow/shared/engagement-template-flow-step.enum';
import { EngagementUserIdTypeEnum } from 'src/app/shared/components/choose-template-flow/shared/engagement-user-id-type.enum';
import { SiteTypeEnum } from 'src/app/shared/enums';
import { SiteV2 } from 'src/app/shared/models';
import { MessageSender } from 'src/app/shared/models/misc.model';
import { KakaotalkService, WhatsappService } from 'src/app/shared/strategies/channels';
import { EngagementAbstractService } from './engagement-abstract.service';
import { EngagementStrategiesService } from './strategies/engagement-strategies.service';

@Injectable({
  providedIn: 'root',
})
export class EngagementService {
  flowStep: EngagementTemplateFlowStepEnum;
  strategy!: EngagementAbstractService;
  allowedChannelTypes = [SiteTypeEnum.WhatsApp, SiteTypeEnum.Kakaotalk];
  allowedChannelTypeIds = [this.whatsappService.getType(), this.kakaotalkService.getType()];

  private _channelType: SiteTypeEnum;
  get channelType(): SiteTypeEnum {
    return this._channelType;
  }
  set channelType(channelType: SiteTypeEnum) {
    this._channelType = channelType;
    this.strategy = this.engagementStrategiesService.getStrategy(this.channelType);
    this.strategy.initTaskProcessContext(true);
  }

  constructor(
    private sitesService: SitesService,
    private engagementStrategiesService: EngagementStrategiesService,
    private whatsappService: WhatsappService,
    private kakaotalkService: KakaotalkService
  ) {}

  tryToFindRecipient(
    siteId: number,
    searchUserExternalType: string,
    userIdType: EngagementUserIdTypeEnum
  ): Observable<MessageSender> {
    if (userIdType) {
      this.strategy.userIdType = userIdType;
    }
    return this.strategy.tryToFindRecipient(siteId, searchUserExternalType);
  }

  clearContext(): void {
    this.strategy.clearContext();
  }

  initContext(siteId: number, userExternalId: string, optionsFromCRM?: string): void {
    if (!this.channelType) {
      this.channelType = this.sitesService.sitesV2Map.get(siteId).typeName;
    }

    if (!this.strategy) {
      this.strategy = this.engagementStrategiesService.getStrategy(this.channelType);
      this.strategy.initTaskProcessContext(true);
    }

    this.strategy.optionsFromCRM = optionsFromCRM;
    this.strategy.initContext(+siteId, userExternalId);
  }

  initializeAccountByDefault(): SiteV2 {
    const site = this.sitesService.sitesV2
      .filter(site => [this.whatsappService.getType(), this.kakaotalkService.getType()].includes(site.type))
      .shift();

    const firstSite = this.sitesService.enrichSiteWithLogo(site);

    this.channelType = firstSite.typeName;
    return firstSite;
  }

  computeUserExternalIds(userExternalId: string) {
    const index = [
      EngagementUserIdTypeEnum.PHONE_NUMBER,
      EngagementUserIdTypeEnum.APP_USER_ID,
      EngagementUserIdTypeEnum.USER_KEY,
    ].indexOf(this.strategy.userIdType);

    const externalUserIds = ['', '', ''] as any;
    externalUserIds.splice(index, 1, userExternalId);
    return externalUserIds.join(',');
  }
}
